// 
// A light wrapper around Sentry which may or may not be defined.
// Webpacked code has the dbg constant provided globally with the
// ProvidePlugin

// Importing Sentry and it's types
//import * as Sentry from "@sentry/browser";

declare const Sentry: typeof import("@sentry/browser");
import type { Client, CaptureContext, Breadcrumb, SeverityLevel } from "@sentry/types";

// Our custom dto for passing sentry data from server
import { SentryContext } from "@/common/types";

const Environment = {
    IsDebugBuild: process.env.NODE_ENV == "development",
    IsProductionBuild: process.env.NODE_ENV == "production",
}


declare global {
    interface Window {
        Sentry: Client
    }
}

export function initializeContext(ctx: SentryContext) {

    if (window.Sentry) {

        console.log('[sentry] Initializing with context', ctx);

        if (ctx.username) {
            Sentry.setUser({ username: ctx.username, id: ctx.userId, ip_address: ctx.ipAddress });
        }

        if (ctx.dealerName || ctx.tenantName) {
            Sentry.setContext("qacontext",
                {
                    dealer: ctx.dealerName,
                    tenant: ctx.tenantName
                });
        }       
    }
}

export function captureMessage(message: string, captureContext?: CaptureContext | SeverityLevel): string {
    return Sentry.captureMessage(message, captureContext);
}

export function captureWarning(message: string, category?: string, data?: any): void {

    let context:CaptureContext = {
        level: "warning",
        extra: data,
        tags: category ? { "category": category } : undefined      
    };

    Sentry.captureMessage(message,context);
    console.warn(`${category} - ${message}`, data);
}



export function captureException(exception: Error | unknown, captureContext?: CaptureContext): string {

    // Calling sentry first as it's our primary exception manager
    const res = Sentry.captureException(exception, captureContext);
    return res;
}

export function dropBreadcrumb(message: string, data?: any): void {
    addBreadcrumb({
        message: message,
        level: "info",
        data: data
    });
}

export function addBreadcrumb(breadcrumb: Breadcrumb): void {

    Sentry.addBreadcrumb(breadcrumb);    
}

const dbg = {
    captureMessage,
    captureException,
    captureWarning,
    addBreadcrumb,
    dropBreadcrumb,
    logWarning: captureWarning,
    initializeContext,
    Environment
};

export default dbg;
export * from "@sentry/types";
